//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import moment from "moment";
import BackendServices from "@/services/backend-services";
import { required } from "@/utils/validations.js";
import { noValidation } from "@/utils/validations.js";
import { validateEmail } from "@/utils/validations.js";
import { validateDate } from "@/utils/validations.js";
import { checkPermission } from "@/utils/permissions-validations.js";

export default {
  name: "traitsTab",
  props: ["value"],
  components: {},
  mounted: function () {
    BackendServices.getMarketTypes().then(response => {
      this.marketTypeList = response.data;
    });
    BackendServices.getStoreChannels().then(response => {
      this.storeChannelList = response.data;
    });

    BackendServices.getWarehouses().then(response => {
      this.warehouseList = response.data;
    });

    this.validateData();
  },
  computed: {
    isNew: function () {
      return this.value.id == null || this.value.id == undefined;
    },
    user_admin: function () {
      return checkPermission("system_settings");
    },
  },
  data: () => ({
    moment,
    tab: "traits",
    time: null,
    weekdays: [
      { id: "0", opening_hour: null, closing_hour: null, expansion: false },
      { id: "1", opening_hour: null, closing_hour: null, expansion: false },
      { id: "2", opening_hour: null, closing_hour: null, expansion: false },
      { id: "3", opening_hour: null, closing_hour: null, expansion: false },
      { id: "4", opening_hour: null, closing_hour: null, expansion: false },
      { id: "5", opening_hour: null, closing_hour: null, expansion: false },
      { id: "6", opening_hour: null, closing_hour: null, expansion: false }
    ],
    validForm: false,
    marketTypeList: [],
    storeChannelList: [],
    warehouseList: []
  }),
  methods: {
    required,
    noValidation,
    validateEmail,
    validateDate,
    updateData() {
      this.$emit("value", this.value);
    },
    dayFormat(item) {
      return moment(item.id, "d").format("ddd");
    },
    EndDateValid(val) {
      if (val) {
        return val > this.value.opening_date || "Data inválida";
      }
    },
    searchFilteredWarehouses(query = null) {
      let filterObject = {};

      if (query) {
        filterObject[3] = {
          column_key: "name",
          include: [query]
        };
      }

      BackendServices.getWarehouses(
        { page: 1, rowsPerPage: 500 },
        filterObject,
        true
      ).then(response => {
        let nameData = Array.isArray(response.data) ? response.data : [];
        this.warehouseList = nameData.map(item => JSON.stringify(item));

        if (query) {
          filterObject[3].column_key = "code";
        }

        BackendServices.getWarehouses(
          { page: 1, rowsPerPage: 500 },
          filterObject,
          true
        ).then(response => {
          let codeData = Array.isArray(response.data) ? response.data : [];
          this.warehouseList.push(codeData.map(item => JSON.stringify(item)));
          this.warehouseList = [...new Set(this.warehouseList.flat())].map(item =>
            JSON.parse(item)
          );
        });
      });
    },
    filterWarehouses: function (name, update) {
      update(async () => {
        await this.searchFilteredWarehouses(name);
        this.warehouseList = this.warehouseList.filter(
          item => item.name.toLowerCase().indexOf(name.toLowerCase()) >= 0
        );
      });
    },
    validateData: function () {
      this.$refs.form.validate().then(success => {
        if (success) {
          this.validForm = true;
          this.$emit("form-valid", this.validForm);
        } else {
          this.validForm = false;
          this.$emit("form-invalid", this.validForm);
        }
      });
    },
    endDateRestriction(val) {
      return val > this.value.opening_date;
    }
  }
};
